module.exports = __webpack_public_path__ + "media/images/sp/brands/tvb/store_hiroshima-a35fbf60dcf674a85fab470c9c320a51.jpg";